module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel10-ac595f280a6ea0c30a56d23ec125869e.jpg";